{
  "code": 200,
  "msg": "操作成功",
  "data": [
      {
          "paperNo": "S202610292224421117",
          "paperName": "math-seven-first-阶段卷",
          "learningGrade": "A",
          "paperType": "stage_exam",
          "questionCount": 15,
          "coreKnowledgePoints": null,
          "consolidationQuestions": null,
          "learnWithMeQuestions": null,
          "tryPracticeQuestions": null,
          "adaptivePracticeQuestions": [
              {
                  "id": 53,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 0,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>在移动支付普及的当下，小明使用某支付软件记录个人资金变动情况。若规定收入50元记为+50，那么账单中出现的“−80”表示的实际含义是（　　）</p>\",\"answerContent\":\"<p>C</p>\",\"analysisContent\":\"<p>【分析】本题考查了相反数，具有相反意义的量，用正负数表示具有相反意义的量是解题的关键．根据题干规定，收入记为正值，则支出应记为负值，“-80”表示支出80元，对应选项中的消费支出．</p><p>【详解】解：∵收入50元记为+50，</p><p>∴支出应记为负值．</p><p>∴“-80”表示消费支出了80元．</p><p>故选：C．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>获得额外奖励80元</p>\"},{\"label\":\"B\",\"value\":\"<p>账户余额增长了80元</p>\"},{\"label\":\"C\",\"value\":\"<p>消费支出了80元</p>\"},{\"label\":\"D\",\"value\":\"<p>投资收益增加80元</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-09 17:14:52",
                  "updateTime": "2026-09-17 14:09:19",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 1
              },
              {
                  "id": 132,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 0,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>若在粮谷计算中，增加1斗记为+1斗，那么减少7斗记为（　）</p>\",\"answerContent\":\"<p>C</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正、负数的意义，根据正负数的意义，增加记为正数，减少记为负数．</p><p>【详解】解：增加1斗记为+1斗，减少7斗应记为负数，即-7斗．故选：C．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>−6斗</p>\"},{\"label\":\"B\",\"value\":\"<p>+6斗</p>\"},{\"label\":\"C\",\"value\":\"<p>−7斗</p>\"},{\"label\":\"D\",\"value\":\"<p>+7斗</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 14:54:01",
                  "updateTime": "2026-09-17 11:25:24",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 2
              },
              {
                  "id": 67,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 0,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>在预报本市某天的天气时，播音员说：“本市，晴，局部多云，零下6℃到5℃”。如果“零下6℃”可表示为“-6℃”，那么“5℃”可表示为（　　）</p>\",\"answerContent\":\"<p>A</p>\",\"analysisContent\":\"<p>【分析】本题考查了相反意义的量．根据相反意义的量，解答即可．</p><p>【详解】解：根据题意，得零下6℃可表示为<span data-latex=\\\"-6^{\\\\circ}\\\\mathrm{C}\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>，则5℃记作<span data-latex=\\\"5^{\\\\circ}\\\\mathrm{C}\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span></p><p>故选：A．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p> 5℃</p>\"},{\"label\":\"B\",\"value\":\"<p> -5℃</p>\"},{\"label\":\"C\",\"value\":\"<p>11℃</p>\"},{\"label\":\"D\",\"value\":\"<p>-1℃</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 09:31:43",
                  "updateTime": "2026-09-17 14:06:23",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 3
              },
              {
                  "id": 158,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 5,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>云台山最高处高出海平面1308米，记为+1308米，吐鲁番盆地是中国海拔最低的盆地，它的最低处（艾丁湖湖底最低处）比海平面低161米，记为（　　）．</p>\",\"answerContent\":\"<p>B</p>\",\"analysisContent\":\"<p>【分析】直接根据正负数的意义求解即可．</p><p>【详解】吐鲁番盆地最低处比海平面低161米，记为-161米，</p><p>故选：B．</p><p>【点睛】此题考查了正负数的意义，理解正负数的意义是解题的关键．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>161米</p>\"},{\"label\":\"B\",\"value\":\"<p>-161米</p>\"},{\"label\":\"C\",\"value\":\"<p>1469米</p>\"},{\"label\":\"D\",\"value\":\"<p>-1469米</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 15:59:17",
                  "updateTime": "2026-09-17 15:02:08",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 4
              },
              {
                  "id": 172,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 5,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>小戴同学的支付宝账单中，收入 3 元表示为 +3 元，那么支出 2 元可表示为（　）</p>\",\"answerContent\":\"<p>D</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的实际应用．根据题意可知，收入为“+”，支出为“-”，据此即可得到答案．</p><p>【详解】解：如果收入3元，记作“+3元”，那么支出2元，记作：-2元，</p><p>故选：D．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>+2 元</p>\"},{\"label\":\"B\",\"value\":\"<p>+1 元</p>\"},{\"label\":\"C\",\"value\":\"<p>-5 元</p>\"},{\"label\":\"D\",\"value\":\"<p>-2 元</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 16:35:58",
                  "updateTime": "2026-09-17 14:49:23",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 5
              },
              {
                  "id": 994,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 5,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>如图是某微信用户收支情况，其中正数表示收款，负数表示付款，则<span data-latex=\\\"-15.25\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span> 表示（       ）</p><p><img src=\\\"http://educateexam.oss-cn-beijing.aliyuncs.com/2026/02/11/f2d7e7a0b23143a39395dbdddada58ed.png\\\" data-src=\\\"http://educateexam.oss-cn-beijing.aliyuncs.com/2026/02/11/f2d7e7a0b23143a39395dbdddada58ed.png\\\" class=\\\"image-node\\\" data-type=\\\"image\\\"></p>\",\"answerContent\":\"<p>D</p>\",\"analysisContent\":\"<p>【分析】根据负数表示付款即可作出判断．</p><p>【详解】由题意，正数表示收款，负数表示付款，则-15.25表示付款15.25元；故选：D</p><p>【点睛】本题考查了正数、负数在实际生活中的应用，用正数、负数可以表示具有相反意义的量．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>付款 - 15.25 元</p><p></p>\"},{\"label\":\"B\",\"value\":\"<p>余额 15.25 元</p>\"},{\"label\":\"C\",\"value\":\"<p>收款 15.25 元</p>\"},{\"label\":\"D\",\"value\":\"<p>付款 15.25 元</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 15:37:51",
                  "updateTime": "2026-09-17 14:30:13",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 6
              },
              {
                  "id": 1064,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 10,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>数学家刘徽在《九章算术》中首先给出了正负数的定义：“今两算得失相反，要令正负以名之”。在课堂抢答活动中，若把得5分记作+5分，则扣3分可记作（　）</p>\",\"answerContent\":\"<p>B</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的意义，熟练掌握相反意义的量是解答本题的关键．根据正数和负数是一组具有相反意义的量，据此即可求解．</p><p>【详解】解：若把得5分记作+5分，则扣3分可记作-3分，故选：B．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>3分　　</p>\"},{\"label\":\"B\",\"value\":\"<p>-3分</p>\"},{\"label\":\"C\",\"value\":\"<p>5分　</p>\"},{\"label\":\"D\",\"value\":\"<p>-5分</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 15:51:00",
                  "updateTime": "2026-09-17 15:33:09",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 7
              },
              {
                  "id": 1386,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 10,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>下列哪一对不是具有相反意义的量？（　　）</p>\",\"answerContent\":\"<p>A</p>\",\"analysisContent\":\"<p>【分析】根据正负数的含义，在用正负数表示向指定方向变化的量时，通常把向指定方向变化的量规定为正数，而把向指定方向的相反方向变化的量规定为负数．</p><p>【详解】解：收入和亏损不具有相反意义，故A符合题意；</p><p>向东和向西具有相反意义，故B不符合题意；</p><p>上升和下降具有相反意义，故C不符合题意；</p><p>前进和后退具有相反意义，故D不符合题意．</p><p>故选：A．</p><p>【点睛】本题主要考查正数和负数的知识点，理解正数与负数的相反意义，比较简单．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>收入100元和亏损200元</p>\"},{\"label\":\"B\",\"value\":\"<p>向东走100米和向西走50</p>\"},{\"label\":\"C\",\"value\":\"<p>水位升高1米和水位下降2米</p>\"},{\"label\":\"D\",\"value\":\"<p>前进50米和后退50米</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 16:52:04",
                  "updateTime": "2026-09-17 15:26:55",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 8
              },
              {
                  "id": 1507,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "select",
                  "learningGrade": "A",
                  "learningForce": 10,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>吐鲁番沙漠植物园低于海平面80.97米，记−80.97米；岠山是邳州市海拔最高的山峰，其最高处高于海平面204.7米，记作（　　）</p>\",\"answerContent\":\"<p>A</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正负数的实际应用，正负数是一对具有相反意义的量，若高于海平面的高度用“+”表示，那么低于海平面的高度就用“-”表示，据此求解即可．</p><p>【详解】解：吐鲁番沙漠植物园低于海平面80.97米，记-80.97米；岠山是邳州市海拔最高的山峰，其最高处高于海平面204.7米，记作+204.7米，</p><p>故选：A．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>+204.7米　</p>\"},{\"label\":\"B\",\"value\":\"<p>−204.7米</p>\"},{\"label\":\"C\",\"value\":\"<p>+285.67米</p>\"},{\"label\":\"D\",\"value\":\"<p>−285.67米</p>\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 17:14:23",
                  "updateTime": "2026-09-17 15:23:45",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 9
              },
              {
                  "id": 90,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "fill_blank",
                  "learningGrade": "A",
                  "learningForce": 0,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>早在公元前5世纪我国春秋战国初期，魏国的相国李悝就在《法经》一书中用“不足”来表示亏空．如果盈余250两记作+250两，那么亏空100两记作<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>两．</p>\",\"answerContent\":\"<p>-100</p>\",\"analysisContent\":\"<p>【分析】根据正负数表示相反意义的量解答即可．</p><p>【详解】解：∵盈余250两记作+250两，</p><p>∴亏空100两记作-100两，</p><p>故答案为：-100．</p><p>【点睛】此题考查了正负数的相反意义，正确理解同一个事件中正负数表示相反意义的量是解题的关键．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 10:45:11",
                  "updateTime": "2026-09-17 14:02:38",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 1
              },
              {
                  "id": 153,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "fill_blank",
                  "learningGrade": "A",
                  "learningForce": 0,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>在下列横线上填上适当的词，使其前后意义相反．</p><p>（1）向东走3米和<u>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</u>走3米；</p><p>（2）某地某天最高气温是零上12℃，最低气温是<u>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; </u>2℃；</p><p>（3）飞机下降0.6千米和<u>&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;</u>1千米；</p><p>（4）弹簧伸长2CM和<u>&nbsp;&nbsp; &nbsp;&nbsp;</u>2CM．</p>\",\"answerContent\":\"<p>&nbsp;向西 ;&nbsp;&nbsp;&nbsp;&nbsp;零下 &nbsp;;&nbsp;&nbsp;&nbsp;上升; &nbsp;&nbsp;缩短</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了具有相反意义的量，正确理解具有相反意义的量是解题的关键．</p><p>【详解】解：（1）东的相反方向是西，所以向东走 3 米和向西走 3 米，二者意义相反，</p><p>故填：向西；</p><p>（2）零上的相反情况是零下，所以某地某天最高气温是零上12℃，最低气温是零下2℃，二者意义相反，</p><p>故填：零下；</p><p>（3）下降的相反动作是上升，所以飞机下降 0.6 千米和上升1 千米，二者意义相反，</p><p>故填：上升；</p><p>（4）伸长的相反变化是缩短，所以弹簧伸长2CM和缩短3CM，二者意义相反，</p><p>故填：缩短．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 15:48:08",
                  "updateTime": "2026-09-17 11:16:12",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 2
              },
              {
                  "id": 773,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "fill_blank",
                  "learningGrade": "A",
                  "learningForce": 5,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>国家航天局消息，6月4日7时38分，嫦娥六号上升器携带月球样品自月球背面起飞，随后成功进入预定环月轨道，圆满完成世界首次月球背面采样和起飞．月球表面白天的温度可达127℃，记作_______，夜间的温度可达零下153℃，记作______．</p>\",\"answerContent\":\"<p>+127℃，-153℃．</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的意义，高于 0℃ 记作正数，低于 0℃ 记作负数，即可求解．</p><p>【详解】解：月球表面白天的温度可达127℃，记作+127℃，夜间的温度可达零下153℃，记作-153℃</p><p>故答案为：+127℃，-153℃．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 11:47:32",
                  "updateTime": "2026-09-17 14:36:01",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 3
              },
              {
                  "id": 936,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "fill_blank",
                  "learningGrade": "A",
                  "learningForce": 5,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>如果将中午12:00定为0，12:00以后为正，单位是小时，那么上午8:00应表示为_________；下午4:30应表示为_______。</p>\",\"answerContent\":\"<p>&nbsp;-4小时 &nbsp;&nbsp;&nbsp;&nbsp;+4.5小时</p>\",\"analysisContent\":\"<p>【分析】在12：00以后为正，则在12：00以前为负．</p><p>【详解】解：上午8：00在12：00以前4个小时，记作-4小时，</p><p>下午4：30在12：00以后4.5个小时，记作+4.5小时，</p><p>故答案为：-4小时，+4.5小时．</p><p>【点睛】本题考查了正负数的表示方法，解题的关键是掌握正负数的相反意义．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 15:27:09",
                  "updateTime": "2026-09-17 14:31:31",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 4
              },
              {
                  "id": 189,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "fill_blank",
                  "learningGrade": "A",
                  "learningForce": 10,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>6月份红星小学每名学生在图书室平均借了6本书．卓玛借了8本，记作+2本；东东借了4本，记作-2本；如果小玲借了5本，应记作<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>本．</p>\",\"answerContent\":\"<p>-1</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正负数的应用，根据卓玛借了8本，记作+2本；东东借了4本，记作-2本，得出借6本书时，应该记作0，然后得出答案即可．</p><p>【详解】解：∵卓玛借了8本，记作+2本；东东借了4本，记作-2本，</p><p>∴小玲借了5本，应记作5-6=-1本，</p><p>故答案为：-1．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-10 17:24:27",
                  "updateTime": "2026-09-17 15:34:37",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 5
              },
              {
                  "id": 1398,
                  "tenantId": "000000",
                  "isStagePaper": 0,
                  "grade": "seven",
                  "subject": "math",
                  "semester": "first",
                  "educationStage": "junior_high",
                  "type": "short_answer",
                  "learningGrade": "A",
                  "learningForce": 10,
                  "module": "match",
                  "difficulty": "1",
                  "questionDetail": "{\"questionContent\":\"<p>（1）如果升降机下降10m记作-10m，那么上升15m记作什么？</p><p>（2）如果+40000元表示在银行存入40000元，那么-3000元表示什么？</p><p>（3）某盐业公司加工的袋装食盐，如果超过标准质量1g记作+1g，那么低于标准质量2g记作什么？</p>\",\"answerContent\":\"<p>（1）+15m；（2）在银行取出 3000 元；（3）-2g</p>\",\"analysisContent\":\"<p>【分析】本题考查了相反意义的量“用正负数表示两种具有相反意义的量，具有相反意义的量都是相互依存的两个量，它包含两个要素，一是它们的意义相反，二是他们都是数量”，熟记相反意义的量的定义是解题关键．根据相反意义的量的定义求解即可得．</p><p>（1）根据上升与下降的意义相反解答即可得；</p><p>（2）根据存入与取出的意义相反解答即可得；</p><p>（3）根据超过与低于的意义相反解答即可得．</p><p>【详解】解：（1）因为上升与下降的意义相反，所以如果升降机下降10m 记作 -10m，那么上升15m 记作 +15m．</p><p>（2）因为存入与取出的意义相反，所以如果 +40000 元表示在银行存入 40000 元，那么 -3000 元表示在银行取出 3000 元．</p><p>（3）因为超过与低于的意义相反，所以如果超过标准质量1g 记作 +1g，那么低于标准质量2g 记作 -2g．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                  "questionDetailJson": null,
                  "status": "0",
                  "textbook": 2,
                  "textbookName": null,
                  "remark": null,
                  "createTime": "2026-02-11 16:54:53",
                  "updateTime": "2026-09-17 15:26:38",
                  "isCanDelete": null,
                  "createName": null,
                  "sortNo": 1
              }
          ],
          "printResult": "试卷打印成功",
          "learningForce": 15,
          "studentInfo": null
      }
  ]
}